import React, { PropsWithChildren } from 'react';
import { Icon, Text } from '@common/components';
import { ColorsType } from 'works/legacy/lib/style-helper';
import { ShiftType } from '@common/graphql';

export function ShiftTypeWithIcon({
  value,
  disabled,
}: {
  value?: ShiftType;
  disabled?: boolean;
}) {
  if (!value) return null;

  const colorHandler = (color: ColorsType) => {
    return disabled ? 'midnightLightest' : color;
  };

  return {
    day: (
      <ShiftItemWrapper label="Day" disabled={disabled}>
        <Icon icon="sun" color={colorHandler('sunDarker')} fit />
      </ShiftItemWrapper>
    ),
    evening: (
      <ShiftItemWrapper label="Evening" disabled={disabled}>
        <Icon icon="sunset" color={colorHandler('harvestGold')} fit />
      </ShiftItemWrapper>
    ),
    night: (
      <ShiftItemWrapper label="Night" disabled={disabled}>
        <Icon icon="moon" color={colorHandler('skyDarker')} fit />
      </ShiftItemWrapper>
    ),
    variable: (
      <ShiftItemWrapper label="Variable" disabled={disabled}>
        <Icon icon="shuffle" color={colorHandler('harvestGold')} fit />
      </ShiftItemWrapper>
    ),
  }[value];
}

function ShiftItemWrapper({
  label,
  children,
  disabled,
}: PropsWithChildren<{
  label: string;
  disabled?: boolean;
}>) {
  return (
    <span className="shift-item-wrapper">
      <span style={{ width: 24, display: 'inline-block' }}>{children}</span>
      <Text secondary={disabled}>{label}</Text>
    </span>
  );
}
